module.exports = __webpack_public_path__ + "fonts/visuelt-pro-light.9d9c4e81.woff2";